import { Box } from "@chakra-ui/react";
import { FC } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import useScreen from "../../hooks/useScreen";
import useSession from "../../hooks/useSession";
import { Channel } from "../../interfaces/tracking";
import { Analytics, EventNames } from "../../utils/tracking";

interface BackButtonProps {
  size?: string;
  color?: string;
  screen?: string;
  funcBack?: () => void;
}

export const BackButton: FC<BackButtonProps> = (props) => {
  const platform: string =
    new URLSearchParams(window.location.search).get("platform") ?? "";

  const { size, color, funcBack, screen } = props;
  const navigate = useNavigate();
  const { isLoggedIn } = useSession();
  const { isMobile } = useScreen();

  const onClick = () => {
    Analytics.event(Channel.GA, EventNames.BACK_SELECTED, {
      login: isLoggedIn(),
      device: isMobile ? "mobile" : "desktop",
      screen: screen ?? "",
    });

    if (funcBack) {
      funcBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      w={props.size ?? "1.875rem"}
      h={props.size ?? "1.875rem"}
      onClick={onClick}
      cursor="pointer"
      transition="0.25s"
      hidden={platform.includes("g-mob")}
      _hover={{
        transform: "scale(1.05)",
      }}
    >
      <IoArrowBack fontSize={size ?? "1.875rem"} color={color ?? "#000"} />
    </Box>
  );
};
